export default __webpack_public_path__ + "static/media/ies_CeciliaRamos.21a38280.png";